import { render, staticRenderFns } from "./pricenew.vue?vue&type=template&id=a7ea0e4c&scoped=true"
import script from "./pricenew.vue?vue&type=script&lang=js"
export * from "./pricenew.vue?vue&type=script&lang=js"
import style0 from "./pricenew.vue?vue&type=style&index=0&id=a7ea0e4c&prod&scoped=true&lang=css"
import style1 from "./pricenew.vue?vue&type=style&index=1&id=a7ea0e4c&prod&lang=css"
import style2 from "./pricenew.vue?vue&type=style&index=2&id=a7ea0e4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ea0e4c",
  null
  
)

export default component.exports